import { createStyles } from '@material-ui/core'

export const stylesMui = (theme) =>
  createStyles({
    content: {
      backgroundColor: '#FAFAFA'
    },
    header: {
      display: 'block',
      marginTop: '1%',
      marginLeft: '90%'
    },
    card: {
      margin: '1%'
    },
    cardContainer: {
      margin: '1%',
      minHeight: '120vh'
    },
    tabsRoot: {
      marginBottom: '-1%',
      marginLeft: '2%'
    }
  })
